import { render, staticRenderFns } from "./procedureTrans.vue?vue&type=template&id=0587c4b4"
import script from "./procedureTrans.vue?vue&type=script&lang=js"
export * from "./procedureTrans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports